import { Header5 } from '@cian/ui-kit';
import cx from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { IBank } from '../../../../../shared/types/banksList';

interface IBanksList {
  banksList: IBank[];
}

export const BanksList: React.FC<IBanksList> = ({ banksList }) => {
  return (
    <div className={styles['banks']}>
      {banksList.map(({ name, icon }, index) => (
        <div key={index} className={styles['bank']}>
          <span className={cx(styles['icon'])} style={{ backgroundImage: `url(${icon})` }} />
          <Header5 as="span">{name}</Header5>
        </div>
      ))}
    </div>
  );
};
